/** @jsx jsx */
import { jsx } from 'theme-ui'
import Grid from '../helpers/grid'
import MoreWinnersCard from './moreWinnersCard'
import WinnersCard from './winnersCard'
import { WINNERS_CONFIG } from './moreInfoConfig'

const MobilesSection = () => (
  <div>
    <div
      sx={{
        textAlign: 'center'
      }}
    >
      <h1
        sx={{
          fontSize: '36px',
          marginBottom: [32, 48],
          marginTop: ['48px', '64px']
        }}
      >
        Top mobile awards
      </h1>
    </div>
    <Grid gridTemplateColumns={'1fr'} gap={[32, 48]}>
      {[
        WINNERS_CONFIG.networkOfTheYearMobiles,
        WINNERS_CONFIG.handsetOfTheYearMobiles
      ].map((award) => (
        <WinnersCard
          key={award.awardTitle}
          awardLabel={award.awardLabel}
          providerName={award.providerName}
          awardTitle={award.awardTitle}
          winnersLogo={award.winnersLogoCard}
          modalContent={award}
          ctaHref={award.providerLink}
          ctaText={award.ctaTitle}
        />
      ))}
    </Grid>

    <div sx={{ textAlign: 'center', mt: 72 }}>
      <h3 sx={{ mb: 64, fontSize: ['28px', '32px'] }}>Networks</h3>
      <Grid
        gridTemplateColumns={[
          'repeat(2, minmax(0, 1fr))',
          'repeat(2, minmax(0, 1fr))',
          'repeat(3, minmax(0, 1fr))'
        ]}
        gap={['8px', '32px']}
      >
        {[
          WINNERS_CONFIG.mostPopularMobileNetwork,
          WINNERS_CONFIG.bestDataMobiles,
          WINNERS_CONFIG.bestDataRoamingMobiles,
          WINNERS_CONFIG.bestMobilesCustomerService,
          WINNERS_CONFIG.bestPerks,
          WINNERS_CONFIG.fastestNetworkMobiles
        ].map((award) => (
          <MoreWinnersCard
            key={award.awardTitle}
            awardSubtitle={award.awardSubtitle}
            awardLabel={award.awardLabel}
            providerName={award.providerName}
            awardTitle={award.awardTitle}
            winnersLogo={award.moreWinnersLogoCard}
            modalContent={award}
            ctaHref={award.providerLink}
            ctaText={award.ctaTitle}
            ctaTextMobile={award.ctaTitleMobile}
          />
        ))}
      </Grid>
    </div>

    <div sx={{ textAlign: 'center', mt: 72 }}>
      <h3 sx={{ mb: 64, fontSize: ['28px', '32px'] }}>
        Handset contract and SIM Only
      </h3>
      <Grid
        gridTemplateColumns={[
          'repeat(2, minmax(0, 1fr))',
          'repeat(2, minmax(0, 1fr))',
          'repeat(3, minmax(0, 1fr))'
        ]}
        gap={['8px', '32px']}
      >
        {[
          WINNERS_CONFIG.bestHandsetContractNetwork,
          WINNERS_CONFIG.bestPAYGMobiles,
          WINNERS_CONFIG.bestSIMOnlyMobiles,
          WINNERS_CONFIG.bestContractValueMobiles,
          WINNERS_CONFIG.bestSIMOValueMobiles,
          WINNERS_CONFIG.bestESIM
        ].map((award) => (
          <MoreWinnersCard
            key={award.awardTitle}
            awardLabel={award.awardLabel}
            awardTitle={award.awardTitle}
            awardSubtitle={award.awardSubtitle}
            providerName={award.providerName}
            winnersLogo={award.moreWinnersLogoCard}
            modalContent={award}
            ctaHref={award.providerLink}
            ctaText={award.ctaTitle}
            ctaTextMobile={award.ctaTitleMobile}
          />
        ))}
      </Grid>
    </div>
  </div>
)

export default MobilesSection
